import React, { useEffect, useState } from 'react';
import { corStats } from '../api';
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';
import { LayoutDashboard, FileText, MessageSquare, Users, Mail, Building2, Package, ShieldAlert, ArrowLeft, LogOut, Receipt, Kanban, Sparkles, CreditCard, Archive } from 'lucide-react';

const AdminLayout = () => {
  const { lang, dir } = useLang();
  const { user, logout } = useAuth();
  const loc = useLocation();
  const [overdue, setOverdue] = useState(0);
  useEffect(() => { corStats().then((s) => setOverdue(s.overdue || 0)).catch(() => {}); }, [loc.pathname]);

  const items = [
    { to: '/admin', label: lang === 'ar' ? 'نظرة عامة' : 'Overview', icon: LayoutDashboard, end: true },
    { to: '/admin/crm', label: 'CRM', icon: Kanban },
    { to: '/admin/correspondence', label: lang === 'ar' ? 'المخاطبات الرسمية' : 'Correspondence', icon: Archive, badge: overdue },
    { to: '/admin/saas-subscribers', label: lang === 'ar' ? 'مشتركو AI' : 'AI Subscribers', icon: CreditCard },
    { to: '/admin/applications', label: lang === 'ar' ? 'الطلبات' : 'Applications', icon: FileText },
    { to: '/admin/receipts', label: lang === 'ar' ? 'الإيصالات' : 'Receipts', icon: Receipt },
    { to: '/admin/contacts', label: lang === 'ar' ? 'رسائل التواصل' : 'Contacts', icon: MessageSquare },
    { to: '/admin/users', label: lang === 'ar' ? 'المستخدمون' : 'Users', icon: Users },
    { to: '/admin/newsletter', label: lang === 'ar' ? 'النشرة البريدية' : 'Newsletter', icon: Mail },
    { to: '/admin/freezones', label: lang === 'ar' ? 'المناطق الحرة' : 'Freezones', icon: Building2 },
    { to: '/admin/packages', label: lang === 'ar' ? 'الباقات' : 'Packages', icon: Package }
  ];

  return (
    <div className="min-h-screen bg-[#f8fafc] pt-20" dir={dir}>
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-8 grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-6">
        {/* Sidebar */}
        <aside className="lg:sticky lg:top-24 lg:h-fit">
          <div className="glass-card rounded-2xl p-4">
            <div className="flex items-center gap-2 px-3 py-2 mb-2">
              <ShieldAlert className="w-4 h-4 text-[#3b82f6]" />
              <div>
                <div className="text-[10px] uppercase tracking-widest text-[#2563eb]">{lang === 'ar' ? 'لوحة الأدمن' : 'Admin Panel'}</div>
                <div className="text-sm text-[#0a0a0a] truncate">{user?.name}</div>
              </div>
            </div>
            <nav className="space-y-1">
              {items.map((it) => (
                <NavLink key={it.to} to={it.to} end={it.end} className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${isActive ? 'bg-[#2563eb]/15 text-[#3b82f6] border border-[#2563eb]/25' : 'text-[#111827]/70 hover:bg-[#2563eb]/5 hover:text-[#3b82f6]'}`}>
                  <it.icon className="w-4 h-4" />
                  <span>{it.label}</span>
                  {it.badge > 0 && <span className="ms-auto min-w-[20px] h-5 px-1.5 rounded-full bg-rose-600 text-white text-[10px] font-bold flex items-center justify-center" data-testid="nav-cor-overdue-badge">{it.badge}</span>}
                </NavLink>
              ))}
            </nav>
            <div className="mt-4 pt-4 border-t border-[#2563eb]/15 space-y-1">
              <Link to="/" className="flex items-center gap-3 px-3 py-2 rounded-lg text-xs text-[#111827]/60 hover:text-[#3b82f6]">
                <ArrowLeft className="w-3.5 h-3.5" /> {lang === 'ar' ? 'الرئيسية' : 'Back to Site'}
              </Link>
              <button onClick={logout} className="flex items-center gap-3 px-3 py-2 rounded-lg text-xs text-rose-400/80 hover:text-rose-400 w-full">
                <LogOut className="w-3.5 h-3.5" /> {lang === 'ar' ? 'تسجيل الخروج' : 'Sign Out'}
              </button>
            </div>
          </div>
        </aside>
        {/* Content */}
        <main className="min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
